<template>
  <highcharts class="visnet-events__chart" :options="chartOptions" />
</template>

<script>
import { mapState } from 'vuex';
import HighchartsMethods from '@/components/mixins/highcharts-methods';
import DateMethods from '@/components/mixins/date-methods';

const ELECTRICAL_CHART_OPTIONS = {
  yAxis: [
    { title: { text: 'Power [W]' }, gridLineWidth: 0.5, showEmpty: false },
    { title: { text: 'Voltage [V]' }, gridLineWidth: 0.5, showEmpty: false },
    { title: { text: 'Degree [\u00B0]' }, gridLineWidth: 0.5, showEmpty: false },
    {
      title: { text: 'Amps [A]' },
      gridLineWidth: 0.5,
      opposite: true,
      showEmpty: false
    },
    {
      title: { text: 'VA [VA]' },
      gridLineWidth: 0.5,
      opposite: true,
      showEmpty: false
    },
    {
      title: { text: 'VAr [VAr]' },
      gridLineWidth: 0.5,
      opposite: true,
      showEmpty: false
    },
    {
      title: { text: 'Percentage [%]' },
      gridLineWidth: 0.5,
      opposite: true,
      showEmpty: false
    }
  ]
};

export default {
  name: 'ElectricalChart',
  mixins: [HighchartsMethods, DateMethods],
  props: {
    activeTimeView: { type: Number, required: true },
    chartData: { type: Array, required: true },
    date: { type: String, required: true }
  },
  computed: {
    ...mapState({
      feederNames: state => state.substationVisnetHub.visnetHub.ways
    }),
    chartOptions() {
      const series = this.chartData;
      const { startDate, endDate } = this.selectTimespan(this.activeTimeView, this.date);
      const xAxis = this.createXAxis({ startDate, endDate, span: this.activeTimeView });
      const tooltip = this.generatePhaseFeederTooltip(this.feederNames);

      return this.generateChart({
        ...ELECTRICAL_CHART_OPTIONS,
        tooltip,
        xAxis,
        series
      });
    }
  }
};
</script>
